import { TerraformingGridSkillLayouts, TerraformingSkillId } from '@nova/types';

/**
 * Per-skill, per-tier grid footprints for grid skills.
 * Placement: worldTile = casterTile + targetingAnchors[snapIndex] + layout[k].
 * Omitted `targetingAnchors` means `[{ x: 0, y: 0 }]` at read time.
 * Completeness is enforced by `satisfies TerraformingGridSkillLayouts` (every skill id × tier).
 */
export const terraformingGridSkillLayouts = {
  [TerraformingSkillId.GrassBurst]: {
    1: {
      layout: [
        { x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 },
        { x: -1, y: 0 }, { x: 0, y: 0 }, { x: 1, y: 0 },
        { x: -1, y: 1 }, { x: 0, y: 1 }, { x: 1, y: 1 }
      ]
    },
    2: {
      layout: [
        { x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 }, { x: 2, y: -1 },
        { x: -1, y: 0 }, { x: 0, y: 0 }, { x: 1, y: 0 }, { x: 2, y: 0 },
        { x: -1, y: 1 }, { x: 0, y: 1 }, { x: 1, y: 1 }, { x: 2, y: 1 }
      ],
      targetingAnchors: [{ x: 0, y: 0 }, { x: -1, y: 0 }]
    },
    3: {
      layout: [
        { x: -2, y: -1 }, { x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 }, { x: 2, y: -1 },
        { x: -2, y: 0 }, { x: -1, y: 0 }, { x: 0, y: 0 }, { x: 1, y: 0 }, { x: 2, y: 0 },
        { x: -2, y: 1 }, { x: -1, y: 1 }, { x: 0, y: 1 }, { x: 1, y: 1 }, { x: 2, y: 1 }
      ]
    }
  },
  [TerraformingSkillId.FlowerWave]: {
    1: {
      layout: [
        { x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 },
        { x: -1, y: 0 }, { x: 0, y: 0 }, { x: 1, y: 0 },
        { x: -1, y: 1 }, { x: 0, y: 1 }, { x: 1, y: 1 }
      ],
      targetingAnchors: [
        { x: 2, y: 0 },
        { x: 2, y: -1 },
        { x: 2, y: -2 },
        { x: 1, y: -2 },
        { x: 0, y: -2 },
        { x: -1, y: -2 },
        { x: -2, y: -2 },
        { x: -2, y: -1 },
        { x: -2, y: 0 },
        { x: -2, y: 1 },
        { x: -2, y: 2 },
        { x: -1, y: 2 },
        { x: 0, y: 2 },
        { x: 1, y: 2 },
        { x: 2, y: 2 },
        { x: 2, y: 1 }
      ]
    },
    2: {
      layout: [
        { x: 0, y: -2 },
        { x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 },
        { x: -2, y: 0 }, { x: -1, y: 0 }, { x: 0, y: 0 }, { x: 1, y: 0 }, { x: 2, y: 0 },
        { x: -1, y: 1 }, { x: 0, y: 1 }, { x: 1, y: 1 },
        { x: 0, y: 2 }
      ],
      targetingAnchors: [
        { x: 3, y: 0 },
        { x: 3, y: -1 },
        { x: 2, y: -2 },
        { x: 1, y: -3 },
        { x: 0, y: -3 },
        { x: -1, y: -3 },
        { x: -2, y: -2 },
        { x: -3, y: -1 },
        { x: -3, y: 0 },
        { x: -3, y: 1 },
        { x: -2, y: 2 },
        { x: -1, y: 3 },
        { x: 0, y: 3 },
        { x: 1, y: 3 },
        { x: 2, y: 2 },
        { x: 3, y: 1 }
      ]
    },
    3: {
      layout: [
        { x: -1, y: -2 }, { x: 0, y: -2 }, { x: 1, y: -2 },
        { x: -2, y: -1 }, { x: -1, y: -1 }, { x: 0, y: -1 }, { x: 1, y: -1 }, { x: 2, y: -1 },
        { x: -2, y: 0 }, { x: -1, y: 0 }, { x: 0, y: 0 }, { x: 1, y: 0 }, { x: 2, y: 0 },
        { x: -2, y: 1 }, { x: -1, y: 1 }, { x: 0, y: 1 }, { x: 1, y: 1 }, { x: 2, y: 1 },
        { x: -1, y: 2 }, { x: 0, y: 2 }, { x: 1, y: 2 }
      ],
      targetingAnchors: [
        { x: 3, y: 0 },
        { x: 3, y: -1 },
        { x: 2, y: -2 },
        { x: 1, y: -3 },
        { x: 0, y: -3 },
        { x: -1, y: -3 },
        { x: -2, y: -2 },
        { x: -3, y: -1 },
        { x: -3, y: 0 },
        { x: -3, y: 1 },
        { x: -2, y: 2 },
        { x: -1, y: 3 },
        { x: 0, y: 3 },
        { x: 1, y: 3 },
        { x: 2, y: 2 },
        { x: 3, y: 1 }
      ]
    }
  }
} as const satisfies TerraformingGridSkillLayouts;
